import { HttpErrorResponse } from "@angular/common/http";
import { Group, GroupList, INITIAL_UPDATE_GROUP_LIST_DTO, UpdateGroupListDTO } from "src/app/_models/Group";
export interface GroupState {
    loading: boolean;

    crudGroupLoader: boolean;
    crudResult: Group;
    crudError: HttpErrorResponse;

    initialList: boolean;
    listRequestDto: UpdateGroupListDTO;
    list: GroupList[];
    listLoader: boolean;
    listError: any;
    listLength: number;
    listPage: number;
    listLengthError: any;
    listUpdateStatus: boolean | any;

    orgCentreGroupList: Group[];
    orgCentreGroupLoader: boolean;
    orgCentreGroupError: HttpErrorResponse

    deleteGroupLoader: boolean;
    isDeleteGroup: boolean;
    deleteGroupError: any;
    currentPageNumber: number;

    learnerIdsToAssignCourse: number[];
}

export const initialGroupState: GroupState = {
    loading: false,

    crudGroupLoader: false,
    crudResult: null,
    crudError: null,

    initialList: true,
    list: [],
    listLoader: false,
    listError: null,
    listLength: 0,
    listLengthError: null,
    listPage: 0,
    listRequestDto: INITIAL_UPDATE_GROUP_LIST_DTO,
    listUpdateStatus: null,

    orgCentreGroupList: [],
    orgCentreGroupLoader: false,
    orgCentreGroupError: null,

    deleteGroupLoader: false,
    isDeleteGroup: false,
    deleteGroupError: null,
    currentPageNumber: 0,

    learnerIdsToAssignCourse: null
}
